import { Routes, Route } from "react-router-dom";
import { Layout } from "@/components/common/Layout";
import { LoginPage } from "@/pages/login/LoginPage";
import { HomePage } from "@/pages/home/HomePage";
import { RolesPage } from "@/pages/roles";
import { CreateRolePage } from "@/pages/roles/create";
import { EditRolePage } from "@/pages/roles/update";
import { UsersPage } from "@/pages/users/UsersPage";
import { AppRoutes } from "@/constants/routes";
import { ContactPage } from "@/pages/contact/ContactPage";
import { RoleAssignationPage } from "@/pages/role-asignation/RoleAssignationPage";
import { UserRoleAssignCreationPage } from "@/pages/role-asignation/add-edit/UserRoleAssignCreationPage";
import { UserRoleAssignUpdatePage } from "@/pages/role-asignation/add-edit/UserRoleAssignUpdatePage";
import { RolesProvider } from "@/providers/RolesProvider";
import { LightMode } from "@/components/ui/color-mode";
import { AccountsPage } from "@/pages/accounts/AccountsPage";
import { PersonsPage } from "@/pages/persons/PersonsPage";
import { PersonDetailPage } from "@/pages/persons/detail/PersonDetailPage";
import { AccountDetailPage } from "@/pages/accounts/detail/AccountDetailPage";
import { CBUPage } from "@/pages/cbu/CbuPage";
import { CashRequestPage } from "@/pages/requests/cash/CashRequestsPage";
import { CashRequestDetailPage } from "@/pages/requests/cash/detail/CashRequestDetailPage";
import { CashRequestCreationPage } from "@/pages/requests/cash/detail/CashRequestCreationPage";
import { PersonCreationPage } from "@/pages/persons/create/PersonCreationPage";
import { PersonAssociateAccountPage } from "@/pages/persons/detail/PersonAssociateAccountPage";
import { PersonUpdatePage } from "@/pages/persons/update/PersonUpdatePage";
import { CheckRequestPage } from "@/pages/requests/check/CheckRequestsPage";
import { CheckRequestCreationPage } from "@/pages/requests/check/detail/CheckRequestCreationPage";
import { CheckRequestDetailPage } from "@/pages/requests/check/detail/CheckRequestDetailPage";
import { TransferRequestsPage } from "@/pages/requests/transfer/TransferRequestsPage";
import { TransferRequestDetailPage } from "@/pages/requests/transfer/detail/TransferRequestDetailPage";
import { PriceBoardPage } from "@/pages/config/price-board/PriceBoardPage";
import { PriceBoardCreateUpdatePage } from "@/pages/config/price-board/create-update/PriceBoardCreateUpdatePage";
import { RequestPoliciesPage } from "@/pages/config/request-policies/RequestPoliciesPage";
import { RequestPolicyCreationPage } from "@/pages/config/request-policies/create-update/RequestPolicyCreationPage";
import { RequestPolicyUpdatePage } from "@/pages/config/request-policies/create-update/RequestPolicyUpdatePage";
import { MotivesPage } from "@/pages/config/motives/MotivesPage";
import { MotiveCreationPage } from "@/pages/config/motives/create/MotiveCreationPage";
import { MotiveUpdatePage } from "@/pages/config/motives/update/MotiveUpdatePage";
import { ScheduledTransferPage } from "@/pages/requests/scheduled-transfer/ScheduledTransferPage";
import { ScheduledTransferRequestDetailPage } from "@/pages/requests/scheduled-transfer/detail/ScheduledTransferDetailPage";
import { NotFoundPage } from "@/components/not-found/NotFoundPage";
import { RelationFieldsPage } from "@/pages/config/relation-fields/RelationFieldsPage";
import { AddHobbiePage } from "@/pages/config/relation-fields/hobbies/AddHobbiePage";
import { EditHobbiePage } from "@/pages/config/relation-fields/hobbies/EditHobbiePage";
import { AddProfessionPage } from "@/pages/config/relation-fields/professions/AddProfessionPage";
import { EditProfessionPage } from "@/pages/config/relation-fields/professions/EditProfessionPage";
import { FinancialMovementsDescPage } from "@/pages/config/financial-movements-desc/FinancialMovementsDescPage";
import { FinancialMovementsDescCreationPage } from "@/pages/config/financial-movements-desc/detail/FinancialMovementsDescCreationPage";
import { FinancialMovementsDescUpdatePage } from "@/pages/config/financial-movements-desc/detail/FinancialMovementsDescUpdatePage";
import { SellOrderPage } from "@/pages/grain-requests/sell-orders/SellOrderPage";
import { SellOrderCreationPage } from "@/pages/grain-requests/sell-orders/create/SellOrderCreationPage";
import { SellOrderDetailPage } from "@/pages/grain-requests/sell-orders/detail/SellOrderDetailPage";
import { NoPermission } from "@/components/no-permission/NoPermission";
import { CounterDeliveryPage } from "@/pages/grain-requests/counter-delivery/CounterDeliveryPage";
import { CounterDeliveryCreationPage } from "@/pages/grain-requests/counter-delivery/create/CounterDeliveryCreationPage";
import { CounterDeliveryDetailPage } from "@/pages/grain-requests/counter-delivery/detail/CounterDeliveryDetailPage";
import { FutureContractsPage } from "@/pages/grain-requests/future-contract/FutureContractsPage";
import { FutureContractCreationPage } from "@/pages/grain-requests/future-contract/create/FutureContractCreationPage";
import { FutureContractDetailPage } from "@/pages/grain-requests/future-contract/detail/FutureContractDetailPage";
import { SlotRequestsPage } from "@/pages/grain-requests/slot-requests/SlotRequestsPage";
import { SlotRequestDetailPage } from "@/pages/grain-requests/slot-requests/detail/SlotRequestDetailPage";
import { FertSlotRequestsPage } from "@/pages/supplies-requests/fertilizer/FertSlotRequests";
import { FertSlotRequestDetailPage } from "@/pages/supplies-requests/fertilizer/detail/FertSlotRequestDetailPage";
import { FertSlotRequestOrderCreationPage } from "@/pages/supplies-requests/fertilizer/order-creation/FertSlotRequestOrderCreationPage";
import { FertSlotRequestOrderEditPage } from "@/pages/supplies-requests/fertilizer/order-edit/FertSlotRequestOrderEditPage";
import { FuelSlotRequestsPage } from "@/pages/supplies-requests/fuel/FuelSlotRequests";
import { FuelSlotRequestDetailPage } from "@/pages/supplies-requests/fuel/detail/FuelSlotRequestDetailPage";
import { FuelSlotRequestOrderCreationPage } from "@/pages/supplies-requests/fuel/order-creation/FuelSlotRequestOrderCreationPage";
import { FuelSlotRequestOrderEditPage } from "@/pages/supplies-requests/fuel/order-edit/FuelSlotRequestOrderEditPage";
import { BackupChecksPage } from "@/pages/requests/backup-checks/BackupChecksPage";
import { BackupCheckDetail } from "@/pages/requests/backup-checks/detail/BackupCheckDetail";
import { MaintenancePage } from "@/pages/config/maintenance/MaintenancePage";
import { ProductsPage } from "@/pages/config/products/ProductsPage";
import { ProductCreationPage } from "@/pages/config/products/create/ProductCreationPage";
import { ProductEditPage } from "@/pages/config/products/edit/ProductEditPage";
import { LegalOnboardingPage } from "@/pages/onboarding/legal/LegalOnboardingPage";
import { LegalOnboardingDetailPage } from "@/pages/onboarding/legal/detail/LegalOnboardingDetailPage";
import { TrucksPage } from "@/pages/config/trucks/TrucksPage";
import { TruckCreationPage } from "@/pages/config/trucks/create/TruckCreationPage";
import { TruckUpdatePage } from "@/pages/config/trucks/update/TruckUpdatePage";
import { DriversPage } from "@/pages/config/drivers/DriversPage";
import { DriverCreationPage } from "@/pages/config/drivers/create/DriverCreationPage";
import { DriverEditPage } from "@/pages/config/drivers/update/DriverEditPage";
import { LogisticHandlingPage } from "@/pages/config/logistic/LogisticHandlingPage";
import { PurchaseOrderIntentPage } from "@/pages/supplies-requests/purchase-order-intent/PurchaseOrderIntentPage";
import { PurchaseOrderIntentDetailPage } from "@/pages/supplies-requests/purchase-order-intent/detail/PurchaseOrderIntentDetailPage";
import { TechniciansPage } from "@/pages/config/technicians/TechniciansPage";
import { TechnicianCreationPage } from "@/pages/config/technicians/create/TechnicianCreationPage";
import { TechnicianEditPage } from "@/pages/config/technicians/update/TechnicianEditPage";
import { NotificationTypesPage } from "@/pages/config/notification-types/NotificationTypesPage";
import { NotificationTypeDetailPage } from "@/pages/config/notification-types/detail/NotificationTypeDetailPage";
import { FieldVisitPage } from "@/pages/ata-rsa-production/field-visit/FieldVisitPage";
import { FieldVisitCreationPage } from "@/pages/ata-rsa-production/field-visit/create/FieldVisitCreationPage";
import { FieldVisitDetailPage } from "@/pages/ata-rsa-production/field-visit/detail/FieldVisitDetailPage";
import { ProductPlanificationPage } from "@/pages/ata-rsa-production/product-planification/ProductPlanificationPage";
import { ProductPlanificationCreationPage } from "@/pages/ata-rsa-production/product-planification/create/ProductPlanificationCreationPage";
import { ProductPlanificationEditPage } from "@/pages/ata-rsa-production/product-planification/detail/ProductPlanificationEditPage";
import { TaxesPage } from "@/pages/config/taxes/TaxesPage";
import { SamplingRequestsPage } from "@/pages/ata-rsa-production/sampling-requests/SamplingRequestsPage";
import { SamplingRequestCreationPage } from "@/pages/ata-rsa-production/sampling-requests/create/SamplingRequestCreationPage";
import { SamplingRequestDetailPage } from "@/pages/ata-rsa-production/sampling-requests/detail/SamplingRequestDetailPage";
import { FlightRequestsPage } from "@/pages/ata-rsa-production/flight-requests/FlightRequestsPage";
import { FlightRequestCreationPage } from "@/pages/ata-rsa-production/flight-requests/create/FlightRequestCreationPage";
import { FlightRequestsDetailPage } from "@/pages/ata-rsa-production/flight-requests/detail/FlightRequestsDetailPage";
import { FertSlotRequestCreationPage } from "@/pages/supplies-requests/fertilizer/create/FertSlotRequestCreationPage";
import { FuelSlotRequestCreationPage } from "@/pages/supplies-requests/fuel/create/FuelSlotRequestCreationPage";
import { ProductionGrainsPage } from "@/pages/production-abm/production-grains/ProductionGrainsPage";
import { ProductionGrainCreationPage } from "@/pages/production-abm/production-grains/create/ProductionGrainCreationPage";
import { ProductionGrainDetailPage } from "@/pages/production-abm/production-grains/detail/ProductionGrainDetailPage";
import { ProductionZonesPage } from "@/pages/production-abm/production-zones/ProductionZonesPage";
import { ProductionZoneCreationPage } from "@/pages/production-abm/production-zones/create/ProductionZoneCreationPage";
import { ProductionZoneDetailPage } from "@/pages/production-abm/production-zones/detail/ProductionZoneDetailPage";
import { ZonalGrossMarginPage } from "@/pages/production-abm/zonal-gross-margin/ZonalGrossMarginPage";
import { ZonalGrossMarginCreationPage } from "@/pages/production-abm/zonal-gross-margin/create/ZonalGrossMarginCreationPage";
import { ExternalTransfersPage } from "@/pages/requests/external-transfer/ExternalTransfersPage";
import { ExternalTransferDetailPage } from "@/pages/requests/external-transfer/detail/ExternalTransferDetailPage";
import { GrossMarginRequestsPage } from "@/pages/ata-rsa-production/gross-margin-requests/GrossMarginRequestsPage";
import { GrossMarginRequestDetail } from "@/pages/ata-rsa-production/gross-margin-requests/detail/GrossMarginRequestDetail";
import { ZonalGrossMarginDetailPage } from "@/pages/production-abm/zonal-gross-margin/detail/ZonalGrossMarginDetailPage";
import { EstablishmentAndFieldsPage } from "@/pages/production-abm/establishments-fields/EstablishmentsAndFieldsPage";
import { EstablishmentAndFieldsDetailPage } from "@/pages/production-abm/establishments-fields/detail/EstablishmentAndFieldsDetailPage";
import { EstablishmentsFieldsRequestsPage } from "@/pages/ata-rsa-production/estabilishment-field-requests/EstablishmentFieldsRequestsPage";
import { EstablishmentsFieldsRequestDetailPage } from "@/pages/ata-rsa-production/estabilishment-field-requests/detail/EstablishmentsFieldsRequestDetailPage";

export const AppRouter = () => {
  return (
    <Routes>
      <Route
        element={
          <RolesProvider>
            <LightMode>
              <Layout />
            </LightMode>
          </RolesProvider>
        }
      >
        <Route path={AppRoutes.HOME} element={<HomePage />} />
        <Route path={AppRoutes.ROLES} element={<RolesPage />} />
        <Route path={AppRoutes.CREATE_ROLE} element={<CreateRolePage />} />
        <Route path={AppRoutes.UPDATE_ROLE} element={<EditRolePage />} />
        <Route path={AppRoutes.USERS} element={<UsersPage />} />
        <Route path={AppRoutes.CONTACT} element={<ContactPage />} />
        <Route path={AppRoutes.ACCOUNTS} element={<AccountsPage />} />
        <Route
          path={AppRoutes.ACCOUNTS_DETAIL}
          element={<AccountDetailPage />}
        />
        <Route path={AppRoutes.PERSONS} element={<PersonsPage />} />
        <Route path={AppRoutes.PERSON_DETAIL} element={<PersonDetailPage />} />
        <Route
          path={AppRoutes.PERSON_ASSOCIATE_ACCOUNT}
          element={<PersonAssociateAccountPage />}
        />
        <Route
          path={AppRoutes.PERSON_CREATE}
          element={<PersonCreationPage />}
        />
        <Route path={AppRoutes.PERSON_UPDATE} element={<PersonUpdatePage />} />
        <Route path={AppRoutes.CBU} element={<CBUPage />} />
        <Route path={"/onboarding"} element={<>Onboarding</>} />
        {/* Solicitudes de efectivo */}
        <Route path={AppRoutes.CASH_REQUESTS} element={<CashRequestPage />} />
        <Route
          path={AppRoutes.CASH_REQUEST_DETAIL}
          element={<CashRequestDetailPage />}
        />
        <Route
          path={AppRoutes.CASH_REQUEST_CREATION}
          element={<CashRequestCreationPage />}
        />
        {/* Solicitudes de Cheque */}
        <Route path={AppRoutes.CHECK_REQUESTS} element={<CheckRequestPage />} />
        <Route
          path={AppRoutes.CHECK_REQUEST_CREATION}
          element={<CheckRequestCreationPage />}
        />
        <Route
          path={AppRoutes.CHECK_REQUEST_DETAIL}
          element={<CheckRequestDetailPage />}
        />
        {/* Solicitudes de Transferencia */}
        <Route
          path={AppRoutes.TRANSFER_REQUESTS}
          element={<TransferRequestsPage />}
        />
        <Route
          path={AppRoutes.TRANSFER_REQUEST_DETAIL}
          element={<TransferRequestDetailPage />}
        />
        <Route
          path={AppRoutes.EXTERNAL_TRANSFER_REQUESTS}
          element={<ExternalTransfersPage />}
        />
        <Route
          path={AppRoutes.EXTERNAL_TRANSFER_REQUEST_DETAIL}
          element={<ExternalTransferDetailPage />}
        />
        {/* Transferencias programadas */}
        <Route
          path={AppRoutes.SCHEDULED_TRANSFER_REQUESTS}
          element={<ScheduledTransferPage />}
        />
        <Route
          path={AppRoutes.SCHEDULED_TRANSFER_DETAIL}
          element={<ScheduledTransferRequestDetailPage />}
        />
        {/* Asignación de roles */}
        <Route path={AppRoutes.USER_ROLES} element={<RoleAssignationPage />} />
        <Route
          path={AppRoutes.USER_ROLE_CREATION}
          element={<UserRoleAssignCreationPage />}
        />
        <Route
          path={AppRoutes.USER_ROLE_EDIT}
          element={<UserRoleAssignUpdatePage />}
        />
        {/* Configuración */}
        <Route path={AppRoutes.PRICE_BOARD} element={<PriceBoardPage />} />
        <Route
          path={AppRoutes.PRICE_BOARD_ADD}
          element={<PriceBoardCreateUpdatePage />}
        />
        <Route path={AppRoutes.TAXES} element={<TaxesPage />} />
        <Route
          path={AppRoutes.REQUEST_POLICIES}
          element={<RequestPoliciesPage />}
        />
        <Route
          path={AppRoutes.REQUEST_POLICIES_ADD}
          element={<RequestPolicyCreationPage />}
        />
        <Route
          path={AppRoutes.REQUEST_POLICIES_EDIT}
          element={<RequestPolicyUpdatePage />}
        />
        <Route path={AppRoutes.MOTIVES} element={<MotivesPage />} />
        <Route path={AppRoutes.MOTIVE_ADD} element={<MotiveCreationPage />} />
        <Route path={AppRoutes.MOTIVE_EDIT} element={<MotiveUpdatePage />} />
        <Route
          path={AppRoutes.RELATION_FIELDS}
          element={<RelationFieldsPage />}
        />
        <Route path={AppRoutes.HOBBIE_ADD} element={<AddHobbiePage />} />
        <Route path={AppRoutes.HOBBIE_EDIT} element={<EditHobbiePage />} />
        <Route
          path={AppRoutes.PROFESSION_ADD}
          element={<AddProfessionPage />}
        />
        <Route
          path={AppRoutes.PROFESSION_EDIT}
          element={<EditProfessionPage />}
        />
        <Route
          path={AppRoutes.FINANCIAL_MOVEMENTS_DESC}
          element={<FinancialMovementsDescPage />}
        />
        <Route
          path={AppRoutes.FINANCIAL_MOVEMENTS_DESC_ADD}
          element={<FinancialMovementsDescCreationPage />}
        />
        <Route
          path={AppRoutes.FINANCIAL_MOVEMENTS_DESC_EDIT}
          element={<FinancialMovementsDescUpdatePage />}
        />
        <Route path={AppRoutes.SELL_ORDERS} element={<SellOrderPage />} />
        <Route
          path={AppRoutes.SELL_ORDER_DETAIL}
          element={<SellOrderDetailPage />}
        />
        <Route
          path={AppRoutes.SELL_ORDER_CREATION}
          element={<SellOrderCreationPage />}
        />

        <Route
          path={AppRoutes.GRAIN_DELIVERY_PAYMENTS}
          element={<CounterDeliveryPage />}
        />
        <Route path={AppRoutes.GRAIN_DELIVERY_DETAIL} element={<CounterDeliveryDetailPage />} />
        <Route path={AppRoutes.GRAIN_DELIVERY_CREATION} element={<CounterDeliveryCreationPage />} />

        <Route path={AppRoutes.GRAIN_FUTURE_CONTRACTS} element={<FutureContractsPage />} />
        <Route path={AppRoutes.GRAIN_FUTURE_CONTRACTS_DETAIL} element={<FutureContractDetailPage />} /> 
        <Route path={AppRoutes.GRAIN_FUTURE_CONTRACTS_CREATION} element={<FutureContractCreationPage />} />

        {/* CUPOS */}

        <Route path={AppRoutes.SLOT_REQUESTS} element={<SlotRequestsPage />} />
        <Route path={AppRoutes.SLOT_REQUEST_DETAIL} element={<SlotRequestDetailPage />} /> 
        <Route path={AppRoutes.SLOT_REQUEST_CREATION} element={<></>} />

        {/* SOLICITUDES INSUMOS */}
        <Route path={AppRoutes.FERT_SLOTS_REQ} element={<FertSlotRequestsPage />} />
        <Route path={AppRoutes.FERT_SLOTS_REQ_DETAIL} element={<FertSlotRequestDetailPage />} />
        <Route path={AppRoutes.FERT_SLOTS_REQ_ORDER_CREATION} element={<FertSlotRequestOrderCreationPage />} />
        <Route path={AppRoutes.FERT_SLOTS_REQ_ORDER_DETAIL} element={<FertSlotRequestOrderEditPage />} />
        <Route path={AppRoutes.FERT_SLOTS_REQ_CREATION} element={<FertSlotRequestCreationPage />} />
        
        <Route path={AppRoutes.FUEL_SLOTS_REQ} element={<FuelSlotRequestsPage />} />
        <Route path={AppRoutes.FUEL_SLOTS_REQ_DETAIL} element={<FuelSlotRequestDetailPage />} />
        <Route path={AppRoutes.FUEL_SLOTS_REQ_ORDER_CREATION} element={<FuelSlotRequestOrderCreationPage />} />
        <Route path={AppRoutes.FUEL_SLOTS_REQ_ORDER_DETAIL} element={<FuelSlotRequestOrderEditPage />} />
        <Route path={AppRoutes.FUEL_SLOTS_REQ_CREATION} element={<FuelSlotRequestCreationPage />} />

        <Route path={AppRoutes.PURCHASE_ORDER_INTENT} element={<PurchaseOrderIntentPage />} />
        <Route path={AppRoutes.PURCHASE_ORDER_INTENT_DETAIL} element={<PurchaseOrderIntentDetailPage />} />
        
        {/* CHEQUES RESPALDO */}
        <Route path={AppRoutes.BACKUP_CHECKS} element={<BackupChecksPage />} />
        <Route path={AppRoutes.BACKUP_CHECKS_DETAIL} element={<BackupCheckDetail />} />

        {/* MANTENIMIENTO MOBILE */}
        <Route path={AppRoutes.APP_MAINTENANCE} element={<MaintenancePage />} />

        {/* MAESTRO DE PRODUCTOS */}
        <Route path={AppRoutes.PRODUCTS} element={<ProductsPage />} />
        <Route path={AppRoutes.PRODUCTS_CREATION} element={<ProductCreationPage />} />
        <Route path={AppRoutes.PRODUCTS_EDIT} element={<ProductEditPage />} />

        {/* ONBOARDING JURIDICO */}
        <Route path={AppRoutes.LEGAL_ONBOARDING} element={<LegalOnboardingPage />} />
        <Route path={AppRoutes.LEGAL_ONBOARDING_DETAIL} element={<LegalOnboardingDetailPage />} />

        {/* MAESTRO DE CAMIONES */}
        <Route path={AppRoutes.TRUCKS} element={<TrucksPage />} />
        <Route path={AppRoutes.TRUCKS_CREATION} element={<TruckCreationPage />} />
        <Route path={AppRoutes.TRUCKS_EDIT} element={<TruckUpdatePage />} />

        {/* MAESTRO DE FLETEROS */}
        <Route path={AppRoutes.DRIVERS} element={<DriversPage />}/>
        <Route path={AppRoutes.DRIVER_CREATION} element={<DriverCreationPage />} />
        <Route path={AppRoutes.DRIVER_EDIT} element={<DriverEditPage />} />

        {/* MAESTRO DE TÉCNICOS */}
        <Route path={AppRoutes.TECHNICIANS} element={<TechniciansPage />} />
        <Route
          path={AppRoutes.TECHNICIAN_CREATION}
          element={<TechnicianCreationPage />}
        />
        <Route path={AppRoutes.TECHNICIAN_DETAIL} element={<TechnicianEditPage />} />

        {/** LOGISTICA COMPLETA */}
        <Route path={AppRoutes.LOGISTIC} element={<LogisticHandlingPage />} />

        {/* TIPOS DE NOTIFICACION */}
        <Route path={AppRoutes.NOTIFICATIONS} element={<NotificationTypesPage />} />
        <Route
          path={AppRoutes.NOTIFICATION_DETAIL}
          element={<NotificationTypeDetailPage />}
        />
        {/* PRODUCCIÓN ATA / RSA */}
        <Route path={AppRoutes.FIELD_VISIT} element={<FieldVisitPage />} />
        <Route
          path={AppRoutes.FIELD_VISIT_CREATION}
          element={<FieldVisitCreationPage />}
        />
        <Route path={AppRoutes.FIELD_VISIT_DETAIL} element={<FieldVisitDetailPage />} />

        <Route path={AppRoutes.PRODUCT_PLANIFICATION} element={<ProductPlanificationPage />} />
        <Route path={AppRoutes.PRODUCT_PLANIFICATION_CREATION} element={<ProductPlanificationCreationPage />} />
        <Route path={AppRoutes.PRODUCT_PLANIFICATION_DETAIL} element={<ProductPlanificationEditPage />} />
        {/* MUESTREO */}
        <Route path={AppRoutes.SAMPLING_REQUESTS} element={<SamplingRequestsPage />} />
        <Route path={AppRoutes.SAMPLING_REQUEST_CREATION} element={<SamplingRequestCreationPage />} />
        <Route path={AppRoutes.SAMPLING_REQUEST_DETAIL} element={<SamplingRequestDetailPage />} />
        {/* VUELO */}
        <Route path={AppRoutes.FLIGHT_REQUESTS} element={<FlightRequestsPage />} />
        <Route path={AppRoutes.FLIGHT_REQUEST_CREATION} element={<FlightRequestCreationPage />} />
        <Route path={AppRoutes.FLIGHT_REQUEST_DETAIL} element={<FlightRequestsDetailPage />} />

        {/* GRANOS PRODUCTIVOS */}
        <Route path={AppRoutes.PRODUCTION_GRAINS} element={<ProductionGrainsPage />} />
        <Route path={AppRoutes.PRODUCTION_GRAINS_CREATION} element={<ProductionGrainCreationPage />} />
        <Route path={AppRoutes.PRODUCTION_GRAINS_DETAIL} element={<ProductionGrainDetailPage />} />

        {/* ZONAS PRODUCTIVAS */}
        <Route path={AppRoutes.PRODUCTION_ZONES} element={<ProductionZonesPage />} />
        <Route path={AppRoutes.PRODUCTION_ZONES_CREATION} element={<ProductionZoneCreationPage />} />
        <Route path={AppRoutes.PRODUCTION_ZONES_DETAIL} element={<ProductionZoneDetailPage />} />

        {/* MARGEN BRUTO ZONAL */}
        <Route path={AppRoutes.ZONAL_GROSS_MARGINS} element={<ZonalGrossMarginPage />} />
        <Route
          path={AppRoutes.ZONAL_GROSS_MARGINS_CREATION}
          element={<ZonalGrossMarginCreationPage />}
        />
        <Route
          path={AppRoutes.ZONAL_GROSS_MARGINS_DETAIL}
          element={<ZonalGrossMarginDetailPage />}
        />
        {/* MARGEN BRUTO PERSONAL */}
        <Route path={AppRoutes.GROSS_MARGIN_REQUESTS} element={<GrossMarginRequestsPage />}/>
        <Route path={AppRoutes.GROSS_MARGIN_REQUESTS_DETAIL} element={<GrossMarginRequestDetail />}/>

        {/* ESTABLECIMIENTOS Y LOTES */}
        <Route path={AppRoutes.ESTABLISHMENTS_MAIN_PAGE} element={<EstablishmentAndFieldsPage />}/>
        <Route path={AppRoutes.ESTABLISHMENT_FIELD_DETAIL} element={<EstablishmentAndFieldsDetailPage />}/>

        {/* SOLICITUDES ESTABLECIMIENTOS Y LOTES */}
        <Route path={AppRoutes.ESTABLISMENT_FIELD_REQUESTS} element={<EstablishmentsFieldsRequestsPage />}/>
        <Route path={AppRoutes.ESTABLISHMENT_FIELD_REQUEST_DETAIL} element={<EstablishmentsFieldsRequestDetailPage />}/>

        {/* NOT FOUND */}
        <Route path={"*"} element={<NotFoundPage />} />
        <Route path={AppRoutes.NO_PERMISSION} element={<NoPermission />} />
      </Route>
      <Route
        path={AppRoutes.LOGIN}
        element={
          <LightMode>
            <LoginPage />
          </LightMode>
        }
      />
    </Routes>
  );
};
